import React, { createContext, useContext } from 'react';
import { config } from './helpers/Config';

const ConfigContext = createContext(config);

export const useConfig = () => useContext(ConfigContext);

export const ConfigProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ConfigContext.Provider value={config}>
    {children}
  </ConfigContext.Provider>
);
